var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{},[_c('ul',[_c('li',[_vm._v("用户协议")]),_vm._v(" "),_c('li',[_vm._v("隐私协议")]),_vm._v(" "),_c('li',[_vm._v("知识产权")])]),_vm._v(" "),_c('p',[_vm._v("© 香港因他科技有限公司")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-228f0851","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/footer/footer.vue
// module id = null
// module chunks = 